<template>
  <div>
    <main class="main">
      <button @click="backStep" class="button button-back"><span>Back</span></button>

      <div class="confirm-wrapper">
        <img src="../assets/icon-tick.svg">
        <p>Your creation has been submitted and saved to your camera roll.</p>
        <p class="white">All that’s left to do is share your creation to Facebook or Instagram with the hashtag <strong>#JEEPCOMP</strong> to be eligible.</p>
      </div>

      <div class="social">
        <a href="https://facebook.com" target="_blank">
          <img src="../assets/square-fb.png">
        </a>
        <a href="https://instagram.com" target="_blank">
          <img src="../assets/square-insta.png">
        </a>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data () {
    return {
      finalImage: this.$store.state.payload.finished_image
    }
  },
  mounted () {
    this.$store.state.isLoading = false
  },
  methods: {
    backStep () {
      this.$router.push({ path: '/grill' })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    min-height: auto;
    margin: 0;
    padding: 0 6% 80px;
    text-align: center;
  }

  .button-back {
    top: -105px !important;
  }

  .confirm-wrapper {
    img {
      width: 60px;
      margin: 30px auto;
    }

    p {
      margin-bottom: 60px;
      font-size: 20px;
      font-weight: 600;
      color: $color-1;
    }

    p.white {
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: white;

      strong {
        color: $color-1;
      }
    }
  }

  .social {
    display: inline-block;
    width: 100%;

    a {
      display: inline-block;
      width: auto;
      margin: 0 15px;
    }

    img {
      width: 50px;
    }
  }

</style>
